module.exports = __webpack_public_path__ + "static/media/jasper-42.9575d676.jpg";